import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from 'components/NoResults/NoResults.scss';

export const NoResults = ({ className, children, text }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={cn(styles.noResults, className)}>
      <FontAwesomeIcon className={styles.icon} icon={faCircleXmark} />
      <p>{children ?? text ?? 'За вашим запитом нічого не знайдено 😕'}</p>
    </div>
  );
};
